import API from '.';

export default class StewardshipType {
  /**
   * The stewardshipType dimension table for UDM
   * @param {number} stewardshipTypeId Id of the stewardshipType.
   * @param {string} stewardshipTypeName Name of the stewardshipType.
   */
  //IsAssignable?
  //IsActive?
  constructor({ stewardshipTypeId, stewardshipTypeName }) {
    this.stewardshipTypeId = stewardshipTypeId;
    this.stewardshipTypeName = stewardshipTypeName;
  }

  static async getAll() {
    const api = await API();
    const { data } = await api.get('/stewardshipType');
    return data.map((d) => new StewardshipType(d));
  }

  static async get(id) {
    const api = await API();
    const { data } = await api.get(`stewardshipType/${id}`);
    return new StewardshipType(data);
  }

  // static async create(data) {
  //   const api = await API();
  //   console.log(data);
  //   const { res } = await api.post('stewardshipType', data);
  //   return res;
  // }

  // static async update (id, data) {
  //   const api = await API();
  //   const { res } = await api.put(`/stewardshipType`, data);
  //   return res;
  // }
}
